export const PATH = {
  HOME: "/procedure/stationary-request",
  CREATE: "/procedure/stationary-request/create/:id",
  DETAIL: "/procedure/stationary-request/detail/:id",
  EDIT: "/procedure/stationary-request/edit/:id",
};
